module.exports = __webpack_public_path__ + "e15.no2.448180c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/e15.no2.jpg
// module id = LlFV
// module chunks = 0